<template>
<div>
    <p v-if="history && !history.length" class="text-muted">No changes yet.</p>
    <table class="table table-sm" v-if="history && history.length">
        <thead>
            <tr>
                <th>Date</th>
                <th>Changed</th>
                <th>From</th>
                <th>To</th>
                <th>By</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(change, idx) in history" :key="idx">
                <td class="text-nowrap">{{ $filters.date(change.date) }}</td>
                <td>
                    <div class="text-muted">{{ change.subject }}</div>
                    {{ change.field }}
                </td>
                <td>{{ change.old }}</td>
                <td>{{ change.new }}</td>
                <td>{{ change.changed_by }}</td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
// Edits to a plan and its tiers, loaded from `url`.
export default {
    props: ['url', ],
    data() {
        return {
            history: null,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(this.url).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.history = resp
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
